// src/subscreens/Home/CategoriesSection.js
import React from 'react';
import '../../../assets/css/home/CategoriesSection.css';

const CategoriesSection = () => {
  const categories = [
    {
      name: "Information Technology",
      image: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=400&h=300&fit=crop"
    },
    {
      name: "Business",
      image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&h=300&fit=crop"
    },
    {
      name: "Arts",
      image: "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=400&h=300&fit=crop"
    },
    {
      name: "Medical",
      image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=400&h=300&fit=crop"
    }
  ];

  return (
    <section className="cs-categories-section py-5">
      <div className="container">
        <div className="row mb-5">
          <div className="col-12 text-center">
            <h2 className="cs-section-title">Live Session Domains</h2>
         
          </div>
        </div>
        <div className="row g-4">
          {categories.map((category, index) => (
            <div className="col-lg-3 col-md-6" key={index}>
              <div className="cs-category-card">
                <div className="cs-category-image-wrapper">
                  <img 
                    src={category.image} 
                    alt={category.name} 
                    className="cs-category-image"
                  />
                </div>
                <h5 className="cs-category-name">{category.name}</h5>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;